import { useSyncExternalStore } from 'react';
import { useTranslation as useI18nextTranslation } from 'react-i18next';
import { getPresentationMode, subscribePresentation } from '../runtime';

// Mode changes redraw translated views while retaining the translator identity.
// Effects depending on t therefore do not refetch data or reset in-progress forms.
// A language change still follows react-i18next's normal subscription.
export function useTranslation(...args) {
  const translation = useI18nextTranslation(...args);
  useSyncExternalStore(subscribePresentation, getPresentationMode);
  return translation;
}
